import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const UserDashboardIntakeIntentsModalLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "UserDashboardIntakeIntentsModal" */
      './UserDashboardIntakeIntentsModal.dynamic'
    ),
  loading: LoadingModal,
});
